import {useAtomValue} from 'jotai';
import styled from 'styled-components';
import {cadastralLayerAtom} from '@/map/atom';
import {CadastralLayer as Layer} from '@/map/modules/Layer';
import {CadastralLegend} from './CadastralLegend';

interface IProps {
  map: naver.maps.Map;
}

export const CadastralLayer = ({map}: IProps) => {
  const activeCadastral = useAtomValue(cadastralLayerAtom);

  if (!activeCadastral) {
    return null;
  }

  return (
    <>
      <Layer map={map} />
      <LegendWrapper>
        <CadastralLegend />
      </LegendWrapper>
    </>
  );
};

const LegendWrapper = styled.div`
  position: absolute;
  bottom: 16px;
  right: 66px;
  z-index: 1;
`;
